import { useState } from "react"
import { Popover, PopoverContent, PopoverTrigger } from "~/shadcn/ui/popover"
import { cn } from "~/common/shadcn-utils"
import FilterIcon from "~/images/icons/filters.svg?react"

export type FilterOption = { id: string; name?: string | null }

export const CandidateTestsFilterDropdown = ({
  filterOptions,
  selectedFilterOptions,
  onFilterChange,
  allowMultiple = false,
  loading,
  buttonLabel,
  popoverHeader,
  negateFilterLabel,
}: {
  filterOptions: FilterOption[] | undefined
  selectedFilterOptions: FilterOption[]
  onFilterChange: (filterOptions: FilterOption[]) => void
  allowMultiple?: boolean
  loading: boolean
  buttonLabel: string
  popoverHeader: string | undefined
  negateFilterLabel: string
}) => {
  const [open, setOpen] = useState(false)

  const handleSelectionChange = (option: FilterOption) => {
    const isSelected = selectedFilterOptions.some((o) => o.id === option.id)
    let newSelection
    if (allowMultiple) {
      newSelection = isSelected
        ? selectedFilterOptions.filter((o) => o.id !== option.id)
        : [...selectedFilterOptions, option]
    } else {
      newSelection = isSelected ? [] : [option]
    }

    onFilterChange(newSelection)
  }

  return (
    <Popover defaultOpen={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={loading}>
        <div
          className={cn(
            "color-gray-999 cursor-pointer flex flex-row gap-2 rounded p-4 border border-gray-E6E6E3 hover:text-white hover:bg-primary hover:border-primary",
            open && "bg-primary"
          )}
        >
          <FilterIcon className="hover:text-white h-6 w-6" />
          <div className="text-base">{buttonLabel}</div>
        </div>
      </PopoverTrigger>
      <PopoverContent
        asChild
        align="start"
        onOpenAutoFocus={(e) => e.preventDefault()}
        className="border-primary"
      >
        <div className="text-gray-999 flex flex-col">
          <div className="text-sm font-medium py-2 text-gray-999">
            {popoverHeader}
          </div>
          <div className="flex flex-col">
            {selectedFilterOptions.length > 0 && (
              <button
                type="button"
                onClick={() => onFilterChange([])} // Clear all selections
                className="border-0 p-2 cursor-pointer text-gray-999 text-left hover:bg-gray-E6E6E3 hover:text-gray-333 rounded"
              >
                {negateFilterLabel}
              </button>
            )}
            {filterOptions?.map((option) => {
              const isSelected = selectedFilterOptions.some(
                (o) => o.id === option.id
              )

              return (
                <button
                  key={option.id}
                  type="button"
                  onClick={() => handleSelectionChange(option)}
                  className={cn(
                    "border-0 p-2 cursor-pointer text-gray-999 text-left hover:bg-gray-E6E6E3 hover:text-gray-333 rounded",
                    isSelected && "text-gray-333"
                  )}
                >
                  {option.name}
                </button>
              )
            })}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
